// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__30cXR","selected":"Chip_selected__3tFs0"};